export const getSelectableOptions = (selectEl) =>
  Array.from(selectEl?.options || []).filter((opt) => opt && !opt.disabled && opt.value);

export const cycleSelect = (selectEl, direction) => {
  if (!selectEl || !direction) return;
  const options = getSelectableOptions(selectEl);
  if (!options.length) return;

  const currentValue = selectEl.value;
  let currentIndex = options.findIndex((opt) => opt.value === currentValue);
  if (currentIndex < 0) currentIndex = 0;

  const nextIndex = (currentIndex + direction + options.length) % options.length;
  const nextValue = options[nextIndex]?.value;
  if (!nextValue || nextValue === selectEl.value) return;

  selectEl.value = nextValue;
  selectEl.dispatchEvent(new Event('change'));
};

export const ensureSelectHasDefault = (selectEl) => {
  if (!selectEl) return false;
  if (selectEl.value) return false;
  const first = getSelectableOptions(selectEl)[0];
  if (!first) return false;
  selectEl.value = first.value;
  return true;
};

export const isSearchDropdownOpen = (selectId) =>
  document.getElementById(`${selectId}-search-trigger`)?.getAttribute('aria-expanded') === 'true';
